export const tooltipContainerStyle = {
  fontSize: "1.2rem",
};
